import React from "react";
import { icons } from "icons";
import NumberFormat from "react-number-format";
import {
    RenderNumber,
    RenderCurrency,
} from "Utils/renderField/renderReadField";
import {validarConfDecimales} from "../../Utils/validaConfiguracionDecimal";
import { fractions } from "utility/variables";

export function formatoCantidad(props) {
    return (cell, producto) => {

        const fractionMap = fractions.reduce((map, fraction) => {
            map[fraction.fraction] = fraction.value;
            return map;
        }, {}); 
                
        const handleFractionChange = (fraction) => {
            const fractionValue = fractionMap[fraction] || 0;
            const integerPart = Math.floor(producto.cantidad || 0);
            const newValue = integerPart + fractionValue;
            producto.currentFraction = fraction;
            props.asignarCantidad(producto, newValue);
        };
                
        const handleIntegerChange = (integerValue) => {
            const fractionValue = fractionMap[producto.currentFraction] || 0;
            const newValue = integerValue + fractionValue;
            props.asignarCantidad(producto, newValue);
        };

        return (
            <div className="d-flex flex-row">
                <button
                    className="btn btn-cantidad-detalle btn-menos"
                    onClick={() => {
                        const cantidad = producto.cantidad
                            ? producto.cantidad
                            : 0;
                        props.asignarCantidad(producto, cantidad - 1);
                    }}
                    type="button"
                >
                    <img src={icons.menos} alt="-" />
                </button>
                {props.conf_tipo_negocio === "Telas" ? (
                    <div className="d-flex flex-row align-items-center">
                        <NumberFormat
                            className="form-control bodega-ingreso text-right"
                            placeholder="0"
                            decimalScale={0}
                            fixedDecimalScale={true}
                            value={Math.floor(producto.cantidad || 0)} 
                            thousandSeparator={true}
                            prefix={""}
                            style={{ padding: "2px" }}
                            onValueChange={(values) => {
                                handleIntegerChange(values.floatValue);
                            }}
                        />
                        <select
                            className="form-control ml-2"
                            style={{ width: "80px" }}
                            value={producto.currentFraction || ""}
                            onChange={(e) => handleFractionChange(e.target.value)}
                        >
                            <option value="">Unidad</option>
                            {fractions.map((fraction) => (
                                <option key={fraction.fraction} value={fraction.fraction}>
                                    {fraction.fraction}
                                </option>
                            ))}
                        </select>
                    </div>
                ) : (
                <NumberFormat
                    className="form-control bodega-ingreso text-right"
                    placeholder="0"
                    decimalScale={producto.producto.a_granel ? 3 : 0}
                    fixedDecimalScale={
                        producto.producto.a_granel ? true : false
                    }
                    value={producto.cantidad}
                    thousandSeparator={true}
                    prefix={""}
                    style={{ padding: "2px" }}
                    onValueChange={(values) => {
                        let val = "";
                        if (
                            values.value != "" &&
                            values.value != undefined &&
                            values.value != null
                        ) {
                            val = producto.producto.a_granel
                                ? parseFloat(values.value)
                                : parseInt(values.value);
                        }
                        props.asignarCantidad(producto, val);
                    }}
                />
                )}
                <button
                    className="btn btn-cantidad-detalle btn-mas"
                    onClick={() => {
                        const cantidad = producto.cantidad
                            ? producto.cantidad
                            : 0;
                        props.asignarCantidad(producto, cantidad + 1);
                    }}
                    type="button"
                >
                    <img src={icons.mas} alt="+" />
                </button>
            </div>
        );
    };
}

export function formatoCosto(props) {
    return (cell, producto) => {
        return (
            <div>
                <NumberFormat
                    className="form-control text-right"
                    placeholder="0"
                    decimalScale={props.conf_empresa? validarConfDecimales(props.conf_empresa): 2}
                    fixedDecimalScale={true}
                    value={producto.costo}
                    thousandSeparator={true}
                    prefix={props.pais == "GT" ? "Q " : "$ "}
                    onValueChange={(values) => {
                        props.asignarCosto(producto, values.value);
                    }}
                />
            </div>
        );
    };
}

export function formatoSubtotal(cell, producto) {
    let subtotal = 0;
    if (producto.cantidad && producto.costo) {
        subtotal = parseFloat(producto.cantidad) * parseFloat(producto.costo);
    }
    return (
        <div>
            <div>
                <RenderCurrency value={subtotal} />
            </div>
        </div>
    );
}
